// TODO: Please remove this file after the release of the new video page.
import Alpine from 'alpinejs';

import '@/stores/video_settings';
import '@/components/paused_banner_ad';

import { VideoPage } from './video';
import { TrackVideoClick } from './track_video_click';
import { getRecommendationStore } from '@/stores/recommendation';
import { appStore } from '@/stores/app';
import { VideoPageSiteData } from './types';

const recommendationStore = getRecommendationStore();
const trackVideoClick = new TrackVideoClick(recommendationStore, 'v2v');
const siteData: VideoPageSiteData = appStore.getPageData<VideoPageSiteData>();

Alpine.data('videoPage', () => new VideoPage(trackVideoClick, recommendationStore, siteData));
